import { render, staticRenderFns } from "./accountMovement.vue?vue&type=template&id=ab24fde4&"
import script from "./accountMovement.vue?vue&type=script&lang=js&"
export * from "./accountMovement.vue?vue&type=script&lang=js&"
import style0 from "./accountMovement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports